(() => {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  const storageKey = 'bucksNewsletterPopupDismissedAt';
  const successKey = 'bucksNewsletterPopupSignedUp';
  const emailClickKey = 'bucksNewsletterPopupEmailClickAt';
  const submittedEmailKey = 'bucksNewsletterPopupSubmittedEmail';
  const delay = Number(popup.dataset.delay || 30000);
  const frequencyDays = Number(popup.dataset.frequencyDays || 14);
  const welcomeEndpoint = String(popup.dataset.welcomeEndpoint || '').trim();
  const params = new URLSearchParams(window.location.search);

  const now = Date.now();
  const dismissedAt = Number(window.localStorage.getItem(storageKey) || 0);
  const signedUp = window.localStorage.getItem(successKey) === 'true';
  const waitMs = Math.max(1, frequencyDays) * 24 * 60 * 60 * 1000;
  const emailClickAt = Number(window.localStorage.getItem(emailClickKey) || 0);

  const hasEmailAttribution = () => {
    const utmMedium = String(params.get('utm_medium') || '').toLowerCase();
    const utmSource = String(params.get('utm_source') || '').toLowerCase();
    const knownParams = ['sib_cuid', 'sib_id', 'utm_campaign', 'utm_content', 'utm_term'];
    return (
      params.get('newsletter_source') === 'brevo_email' ||
      utmMedium === 'email' ||
      utmSource.includes('brevo') ||
      utmSource.includes('sendinblue') ||
      knownParams.some((key) => params.has(key))
    );
  };

  const form = popup.querySelector('#NewsletterPopupForm');
  const successPanel = popup.querySelector('[data-newsletter-popup-success]');
  const resendButton = popup.querySelector('[data-newsletter-popup-resend]');
  const resendStatus = popup.querySelector('[data-newsletter-popup-resend-status]');

  const submittedEmail = () => String(window.localStorage.getItem(submittedEmailKey) || '').trim();

  const closePopup = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('newsletter-popup-open');
    window.localStorage.setItem(storageKey, String(Date.now()));
  };

  const openPopup = ({ focusEmail = true } = {}) => {
    popup.hidden = false;
    document.documentElement.classList.add('newsletter-popup-open');
    if (focusEmail) popup.querySelector('input[type="email"]')?.focus({ preventScroll: true });
  };

  const showSuccessState = () => {
    if (form) form.hidden = true;
    if (successPanel) successPanel.hidden = false;
    if (resendButton) resendButton.hidden = !submittedEmail();
    if (resendStatus) resendStatus.textContent = '';
  };

  const sendWelcomeEmail = async (email) => {
    if (!welcomeEndpoint || !email) return null;
    const response = await fetch(welcomeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        email,
        source: 'shopify-newsletter-popup',
        path: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error('Welcome email request failed.');
    return response.json().catch(() => null);
  };

  if (params.get('newsletter_popup') === 'success') {
    window.localStorage.setItem(successKey, 'true');
    window.localStorage.setItem(storageKey, String(now));
    showSuccessState();
    openPopup({ focusEmail: false });
  } else if (hasEmailAttribution()) {
    window.localStorage.setItem(emailClickKey, String(now));
  } else if (!signedUp && (!dismissedAt || now - dismissedAt > waitMs) && (!emailClickAt || now - emailClickAt > waitMs)) {
    window.setTimeout(openPopup, Math.max(0, delay));
  }

  popup.querySelectorAll('[data-newsletter-popup-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  form?.addEventListener('submit', (event) => {
    if (!welcomeEndpoint || !event.target?.checkValidity?.()) return;
    const form = event.target;
    const email = form.querySelector('input[type="email"]')?.value || '';
    if (!email.trim()) return;
    window.localStorage.setItem(submittedEmailKey, email.trim());

    sendWelcomeEmail(email.trim()).catch(() => {});
  });

  resendButton?.addEventListener('click', async () => {
    const email = submittedEmail();
    if (!email || !welcomeEndpoint) return;
    resendButton.disabled = true;
    if (resendStatus) resendStatus.textContent = 'Sending...';
    try {
      const result = await sendWelcomeEmail(email);
      if (resendStatus) {
        resendStatus.textContent = result?.welcomeEmailSent === false
          ? 'The email was already sent recently. Please check your inbox or try again in a minute.'
          : 'Sent. Please check your inbox.';
      }
    } catch {
      if (resendStatus) resendStatus.textContent = 'Could not resend right now. Please try again in a minute.';
    } finally {
      resendButton.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();
  });
})();
